import { API_URL } from "@/config";
import { DeployedScannersResponse } from "@/helpers/types";
import axios from "axios";

export const deployScannerRequest = async (
  keygen: string,
  universe_id: string,
  userInfo: any
) => {
  const url = new URL("deploy_scanner", API_URL);
  url.searchParams.append("keygen", keygen);
  url.searchParams.append("universe_id", universe_id);
  try {
    const res = await axios.post(
      url.toString(),
      {},
      {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
        },
      }
    );
    return res;
  } catch (error: any) {
    return error;
  }
};

export const getScannerDeploymentsRequest = async (
  userInfo: any,
  page: number,
  pageSize: number
) => {
  const url = new URL("get_scanner_deployments", API_URL);
  url.searchParams.append("user_id", userInfo?.user_id);
  url.searchParams.append("page", page.toString());
  url.searchParams.append("size", pageSize.toString());

  let error = null;
  let response: DeployedScannersResponse | null = null;

  try {
    const res = await axios.post(
      url.toString(),
      {},
      {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
        },
      }
    );
    response = res.data;
  } catch (error: any) {
    error = error;
  }

  return { response, error };
};

export const undeployScannerRequest = async (
  deploymentId: string,
  userInfo: any
) => {
  const url = new URL("undeploy_scanner", API_URL);
  url.searchParams.append("deployment_id", deploymentId);
  url.searchParams.append("user_id", userInfo?.user_id);
  let error = null;
  let response = null;
  try {
    const res = await axios.post(
      url.toString(),
      {},
      {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
        },
      }
    );
    response = res.data;
  } catch (error: any) {
    error = error;
  }
  return { response, error };
};
